<template>
  <div class="issueDetail">
    <el-menu
      class="el-menu-top"
      mode="horizontal"
      text-color="#000"
      active-text-color="#409EFF"
    >
      <el-menu-item class="tabActive">下发至桩</el-menu-item>
    </el-menu>
    <div class="issue-tip">
      <i class="el-icon-info"></i>
      下发失败的桩可勾选后点击「重新下发」进行重试
    </div>
    <div class="issueDetail_table">
      <el-table
        ref="multipleTable"
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        max-height="90%"
        :header-cell-style="{
          color: 'rgba(255,255,255,1)',
          'font-weight': 'bold',
        }"
        class="public_tableColumn"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="checkSelectable"
        >
        </el-table-column>
        <el-table-column prop="ormtb602ca00" label="桩编号">
          <template slot-scope="scope">
            <p>
              <span
                :class="{
                  active_color_white: scope.row.ormtb602ca02 == '成功',
                }"
                >{{ scope.row.ormtb602ca00 }}</span
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb601CA00" label="归属站点">
          <template slot-scope="scope">
            <p>
              <span
                :class="{
                  active_color_white: scope.row.ormtb602ca02 == '成功',
                }"
                >{{ scope.row.ormtb601CA00 }}</span
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb602ca03" label="桩名称">
          <template slot-scope="scope">
            <p>
              <span
                :class="{
                  active_color_white: scope.row.ormtb602ca02 == '成功',
                }"
                >{{ scope.row.ormtb602ca03 }}</span
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb602ca02" label="下发状态">
          <template slot-scope="scope">
            <p>
              <span
                :class="[
                  scope.row.ormtb602ca02 == '失败'
                    ? 'active_color_red'
                    : 'active_color_blue',
                ]"
                >下发{{ scope.row.ormtb602ca02 }}</span
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb602ca04" label="下发时间">
          <template slot-scope="scope">
            <p>
              <span
                :class="{
                  active_color_white: scope.row.ormtb602ca02 == '成功',
                }"
                >{{ scope.row.ormtb602ca02 == '成功' ? (scope.row.ormtb602ca04 || '-') : '-' }}</span
              >
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pulbic_pagesize">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageMo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limitMo"
        layout="total,sizes, prev, pager, next, jumper"
        :total="pagingPageMo"
      >
      </el-pagination>
    </div>
    <!-- 提交按钮 -->
    <div class="submit_btns">
      <el-button class="submit_btns_left" @click="cancelForm">取消</el-button>
      <el-button type="primary" :disabled="!multipleSelection.length" @click="submitForm">
        <i class="el-icon-refresh-right"></i>重新下发
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'issueDetail',
  data() {
    return {
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      tableData: [],
      multipleSelection: [],
    }
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  watch: {
    id: {
      handler(newVal) {
        this.getPileDetail()
      },
      immediate: true,
    },
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    checkSelectable(row, index) {
      return row.ormtb602ca02 == '失败'
    },
    // 获取下发桩详情
    getPileDetail() {
      var url = 'orm/ormtb602/selectDetailPageList'
      this.axios
        .post(url, {
          ormtb608id: this.id,
          page: this.pageMo,
          limit: this.limitMo,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.tableData = res.data.data
            this.pagingPageMo = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = 10
      this.getPileDetail()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.getPileDetail()
    },
    cancelForm() {
      this.$emit('issueCancel')
    },
    submitForm() {
      let ormtb602ca00s = this.multipleSelection
        .map(item => item.ormtb602ca00)
        .join(',')
      var url = 'orm/ormtb608/issued'
      this.axios
        .post(url, { ormtb608id: this.id, ormtb602ca00s: ormtb602ca00s })
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.$emit('issueSubmit')
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.el-menu-top {
  border-bottom: 1px solid #cdcdcd !important;
}

.tabActive {
  position: relative;
  color: #199fff !important;
  font-size: 18px;
}

.tabActive::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #199fff;
}

.issue-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  color: #d46b08;
  font-size: 13px;
  line-height: 1.5;
}

.issue-tip i {
  font-size: 16px;
  flex-shrink: 0;
}

.issueDetail_table {
  margin-top: 20px;
}

/* 提交按钮 */
.submit_btns {
  padding-top: 20px;
  display: flex;
  justify-content: end;
}

.submit_btns_left {
  color: #d9d9d9;
}

.active_color_red {
  color: #ff0000;
}

.active_color_blue {
  color: #199fff;
}

.active_color_white {
  color: #aaaaaa;
}
</style>

<style scoped>
.issueDetail {
  background: #fffdfa;
}

.el-menu-top {
  border: 1px solid rgba(231, 224, 210, 0.95) !important;
  border-radius: 12px;
  background: #fffaf1;
  overflow: hidden;
}

.tabActive {
  position: relative;
  color: #b56f18 !important;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 1px;
}

.tabActive::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 18px;
  right: 18px;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, #cf8730 0%, #b56f18 100%);
}

.issueDetail_table {
  margin-top: 16px;
  border: 1px solid rgba(231, 224, 210, 0.95);
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.issueDetail_table /deep/.el-table th {
  background: linear-gradient(180deg, #d9a75f 0%, #bc7c28 100%) !important;
  color: #fff !important;
}

.issueDetail_table /deep/.el-table td {
  color: #33485c;
}

.pulbic_pagesize {
  margin-top: 14px;
}

.submit_btns {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  padding-top: 16px;
  margin-top: 18px;
  border-top: 1px solid rgba(231, 224, 210, 0.95);
}

.submit_btns_left {
  color: #9d650f;
}

.active_color_red {
  color: #d94c35;
  font-weight: 700;
}

.active_color_blue {
  color: #1f7fb3;
  font-weight: 700;
}

.active_color_white {
  color: #aaaaaa;
}
</style>
